import React, { useState, useEffect } from "react";
import InfoCard from "../components/InfoCard";

const Section6_1 = ({ contenuti, cards }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {contenuti.map((content, index) => {
        const { titolo1, titolo2, descrizione, immagineBg } = content;
        return (
          <div
            key={index}
            className="container-fluid d-flex flex-column align-items-center position-relative"
            style={{
              padding: "76px 16px",
              gap: "16px",
              backgroundImage: `var(--bg-dark-theme)`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="position-absolute w-100 head-onda reverse">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1440 50"
                preserveAspectRatio="none"
                className="w-100"
              >
                <path
                  fill="#fff"
                  d="M0,50L80,45C160,40,320,30,480,25C640,20,800,20,960,25C1120,30,1280,40,1360,45L1440,50L1440,50L1360,50C1280,50,1120,50,960,50C800,50,640,50,480,50C320,50,160,50,80,50L0,50Z"
                />
              </svg>
            </div>
            {/* Titolo della sezione */}
            <div className="container title-section text-center">
              <span
                className={`white-text ${isMobile
                    ? "d-inline-block d-lg-none title-section-mobile"
                    : "d-none d-lg-inline-block title-section"
                  }`}
              >
                {titolo1}
              </span>{" "}
              <span
                className={`light-green-text ${isMobile
                    ? "d-inline-block d-lg-none title-section-mobile"
                    : "d-none d-lg-inline-block title-section"
                  }`}
              >
                {titolo2}
              </span>
              {descrizione && (
                <p
                  className="custom-text white-text my-5 text-start"
                  dangerouslySetInnerHTML={{ __html: descrizione }}
                />
              )}
            </div>

            {/* Contenitore per le righe delle card */}
            <div className="container d-flex flex-column m-0 p-0">
              {/* Prima riga di 3 card */}
              <div className="row">
                {cards.slice(0, 3).map((card, index) => {
                  const { immagine, superText, sottotitolo, descrizione } =
                    card;
                  return (
                    <div key={index} className="col-md-4">
                      {/* 3 card per riga senza margini e padding */}
                      <InfoCard
                        img={immagine}
                        superText={superText}
                        subtitle={sottotitolo}
                        text={
                          <span
                            dangerouslySetInnerHTML={{ __html: descrizione }}
                          />
                        }
                      />
                    </div>
                  );
                })}
              </div>

              {/* Seconda riga di 3 card */}
              <div className="row">
                {cards.slice(3, 6).map((card, index) => {
                  const { immagine, superText, sottotitolo, descrizione } =
                    card;
                  return (
                    <div key={index + 3} className="col-md-4">
                      {/* 3 card per riga senza margini e padding */}
                      <InfoCard
                        img={immagine}
                        superText={superText}
                        subtitle={sottotitolo}
                        text={
                          <span
                            dangerouslySetInnerHTML={{ __html: descrizione }}
                          />
                        }
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Section6_1;
